<form [formGroup]="formDetalhe">
  <div class="row">
    <div class="form-group col-md-4">
      <label>Data da LIQ</label>
      <input id="dataLiq" formControlName="dataLiq"  type="text" class="form-control" 
      [value]="formDetalhe.get('dataLiq').value | date:'dd/MM/yyyy'">
    </div>
    <div class="form-group col-md-4">
      <label>Nº da LIQ</label>
      <input id="numeroLiq" formControlName="numeroLiq" type="text" class="form-control" [mask]="pedEmpLiqMask">
    </div>
    <div class="form-group col-md-4">
      <label>Valor da LIQ</label>
      <input id="valorLiq" formControlName="valorLiq" type="text" class="form-control" 
        currencyMask [options]="{ precision: 2, prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false, allowZero: true}">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Nº do PED</label> 
      <input id="numeroPed" formControlName="numeroPed"  type="text" class="form-control" [mask]="pedEmpLiqMask">
    </div>
    <div class="form-group col-md-4">
      <label>Nº do EMP</label>
      <input id="numeroEmp" formControlName="numeroEmp" type="text" class="form-control" [mask]="pedEmpLiqMask">
    </div>
    <div class="form-group col-md-4">
      <label>Nº do Processo SEI</label>
      <input id="numeroProcessoSei" formControlName="numeroProcessoSei" type="text" class="form-control" [mask]="getProcessoSeiMask()">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <label>Histórico da LIQ</label> 
      <textarea id="historico" formControlName="historico"  type="text" class="form-control" rows="2"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Código do Credor</label> 
      <input id="codigoCredor" formControlName="codigoCredor"  type="text" class="form-control"  [mask]="codigoCredorMask">
    </div>
    <div class="form-group col-md-4">
      <label>CPF/CNPJ do Credor</label>
      <input id="cpfCnpjCredor" formControlName="cpfCnpjCredor" type="text" class="form-control" 
        [mask]="getCpfCnpjMask('cpfCnpjCredor')">
    </div>
    <div class="form-group col-md-4">
      <label>Forma de Recebimento</label>
      <input id="formaRecebimento" formControlName="formaRecebimento" type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label>Tipo Conta do Credor</label>
      <input id="tipoContaCredor" formControlName="tipoContaCredor" type="text" class="form-control">
    </div>
    <div class="form-group col-md-8">
      <label>Banco do Credor</label> 
      <input id="codBancoCredor" formControlName="codBancoCredor"  type="text" class="form-control">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Agência do Credor</label>
      <input id="codAgenciaCredor" formControlName="codAgenciaCredor" type="text" class="form-control">
    </div>
    <div class="form-group col-md-8">
      <label>Conta do Credor</label>
      <input id="contaCredor" formControlName="contaCredor" type="text" class="form-control">
    </div>

  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <label>Nome do Credor</label>
      <input id="nomeCredor" formControlName="nomeCredor" type="text" class="form-control">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
    <ng-container *ngIf="liquidacao?.consignatarias?.length > 0;">
    <aslib-grid #grid id="grid"  name="grid" headerTitle="Detalhes Consignatária" [(dataset)]="this.liquidacao.consignatarias" 
    [selectOnRowClick]="false" [pagination]="false" [regPerPageVisible]="false">  

      <aslib-grid-column [property]="'codigoCredorConsignataria'" header="Código da Consignatária" class="text-left" [width]="120"
        [sortable]="false" [resizable]="true">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.codigoCredorConsignataria | credor}}</span>
          </ng-template>
      </aslib-grid-column>
      <aslib-grid-column [property]="'nomeCredorConsignataria'" header="Consignatária" class="text-left"  
        [sortable]="false" [resizable]="false">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.nomeCredorConsignataria}}</span>
          </ng-template>
      </aslib-grid-column>
      <aslib-grid-column [property]="'valorConsignataria'" header="Valor da Consignatária" class="text-right" [width]="120" 
        [sortable]="false" [resizable]="false">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.valorConsignataria | currency:'BRL'}}</span>
          </ng-template>
      </aslib-grid-column>       
  </aslib-grid>
  </ng-container>
  </div>
  </div>
</form>

<style>
  .aslib-grid-wrapper{
    margin-bottom: 0px !important;
  }
  .form-group {
    margin-bottom: 0.5rem !important;
  }
  </style>


// WEBPACK FOOTER //
// ./src/app/pagamento/relatorios/detalhe-liquidacao/detalhe-liquidacao.component.html